// extracted by mini-css-extract-plugin
module.exports = {"detail_btn":"graphdashboard_detail_btn__3Z7Ou"};